import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ContactPage() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/contact", form);
            toast.success("Message envoyé. Réponse sous 24-48h.");
            setForm({ name: "", email: "", message: "" });
        } catch {
            toast.error("Erreur — réessayez.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16" data-testid="contact-page">
            <h1 className="font-serif-luxe text-3xl sm:text-5xl chrome-text font-semibold mb-4">Contact</h1>
            <p className="text-slate-400 mb-10">Une question sur une pièce, une commande, un retour ? Écrivez-nous.</p>
            <form onSubmit={submit} className="glass-card rounded-2xl p-6 space-y-4" data-testid="contact-form">
                <div>
                    <label>Nom</label>
                    <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                </div>
                <div>
                    <label>Courriel</label>
                    <input data-testid="contact-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                </div>
                <div>
                    <label>Message</label>
                    <textarea data-testid="contact-message" required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
                </div>
                <button data-testid="contact-submit-btn" type="submit" disabled={loading} className="btn-primary w-full">
                    {loading ? "Envoi…" : "Envoyer"}
                </button>
            </form>
        </div>
    );
}
